"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotFoundScreen = NotFoundScreen;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _styles = require("../shared/styles");

var _PuzzlePieces = require("./PuzzlePieces");

var _SupportFeature = require("../SupportFeature");

var _SearchBlock = require("../SearchBlock");

var _excluded = ["repoUrl", "latestVersionString", "apiKey", "includeSpacing"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Content = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ec4uu4z7"
} : {
  target: "ec4uu4z7",
  label: "Content"
})(function (props) {
  return props.includeSpacing && /*#__PURE__*/(0, _theming.css)(_styles.pageMargins, " padding-top:5rem;padding-bottom:5rem;" + (process.env.NODE_ENV === "production" ? "" : ";label:Content;"));
}, ";");
var Hero = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ec4uu4z6"
} : {
  target: "ec4uu4z6",
  label: "Hero"
})(process.env.NODE_ENV === "production" ? {
  name: "s4g38o",
  styles: "max-width:460px;margin:0 auto 5rem auto;position:relative"
} : {
  name: "s4g38o",
  styles: "max-width:460px;margin:0 auto 5rem auto;position:relative",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Copy = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "ec4uu4z5"
} : {
  target: "ec4uu4z5",
  label: "Copy"
})(process.env.NODE_ENV === "production" ? {
  name: "1c4xyse",
  styles: "position:absolute;top:0;left:0;bottom:0;right:0;display:flex;flex-direction:column;align-items:center;justify-content:center;pointer-events:none"
} : {
  name: "1c4xyse",
  styles: "position:absolute;top:0;left:0;bottom:0;right:0;display:flex;flex-direction:column;align-items:center;justify-content:center;pointer-events:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Title = (0, _theming.styled)("h1", process.env.NODE_ENV === "production" ? {
  target: "ec4uu4z4"
} : {
  target: "ec4uu4z4",
  label: "Title"
})(_styles.marketing.hero1, ";color:", _styles.color.midnight, ";");
var Description = (0, _theming.styled)("p", process.env.NODE_ENV === "production" ? {
  target: "ec4uu4z3"
} : {
  target: "ec4uu4z3",
  label: "Description"
})(_styles.text.large, ";margin:0;text-align:center;color:", _styles.color.darker, ";");
var DiscordIcon = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Icon, process.env.NODE_ENV === "production" ? {
  target: "ec4uu4z2"
} : {
  target: "ec4uu4z2",
  label: "DiscordIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "6dt5g1",
  styles: "color:#5a65ea"
} : {
  name: "6dt5g1",
  styles: "color:#5a65ea",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var GithubIcon = ( /*#__PURE__*/0, _theming.styled)(_designSystem.Icon, process.env.NODE_ENV === "production" ? {
  target: "ec4uu4z1"
} : {
  target: "ec4uu4z1",
  label: "GithubIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "rukwhn",
  styles: "color:#333333"
} : {
  name: "rukwhn",
  styles: "color:#333333",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var StyledSupportFeatureGrid = ( /*#__PURE__*/0, _theming.styled)(_SupportFeature.SupportFeatureGrid, process.env.NODE_ENV === "production" ? {
  target: "ec4uu4z0"
} : {
  target: "ec4uu4z0",
  label: "StyledSupportFeatureGrid"
})(process.env.NODE_ENV === "production" ? {
  name: "ddxhyk",
  styles: "max-width:800px"
} : {
  name: "ddxhyk",
  styles: "max-width:800px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

function NotFoundScreen(_ref) {
  var repoUrl = _ref.repoUrl,
      latestVersionString = _ref.latestVersionString,
      apiKey = _ref.apiKey,
      _ref$includeSpacing = _ref.includeSpacing,
      includeSpacing = _ref$includeSpacing === void 0 ? true : _ref$includeSpacing,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Content, (0, _extends2["default"])({
    includeSpacing: includeSpacing
  }, props), /*#__PURE__*/_react["default"].createElement(Hero, null, /*#__PURE__*/_react["default"].createElement(_PuzzlePieces.PuzzlePieces, null), /*#__PURE__*/_react["default"].createElement(Copy, null, /*#__PURE__*/_react["default"].createElement(Title, null, "404"), /*#__PURE__*/_react["default"].createElement(Description, null, "The page you were looking for couldn\u2019t be found. It may have moved. Try double-checking the link or going back."))), /*#__PURE__*/_react["default"].createElement(StyledSupportFeatureGrid, null, /*#__PURE__*/_react["default"].createElement(_SearchBlock.SearchBlock, {
    version: latestVersionString,
    apiKey: apiKey
  }), /*#__PURE__*/_react["default"].createElement(_SupportFeature.SupportFeature, {
    image: /*#__PURE__*/_react["default"].createElement(DiscordIcon, {
      icon: "discord",
      "aria-label": "Discord"
    }),
    title: "Ask a question in #support chat",
    desc: "Resolve issues with community help. A maintainer is usually online."
  }, /*#__PURE__*/_react["default"].createElement(_designSystem.Link, {
    withArrow: true,
    href: "https://discord.gg/storybook"
  }, "Chat now")), /*#__PURE__*/_react["default"].createElement(_SupportFeature.SupportFeature, {
    image: /*#__PURE__*/_react["default"].createElement(GithubIcon, {
      icon: "github",
      "aria-label": "Github"
    }),
    title: "File an issue on GitHub",
    desc: "Please report issues, someone else may have the same issue."
  }, /*#__PURE__*/_react["default"].createElement(_designSystem.Link, {
    withArrow: true,
    href: repoUrl
  }, "View GitHub issues"))));
}